import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';

import { GENRE_PROPTYPE } from 'common/constants/commonPropTypes';
import UserCard from './components/UserCard/UserCard';
import SearchHeader from './components/SearchHeader/SearchHeader';
import SelectAllCheckbox from './components/SelectAllCheckbox/SelectAllCheckbox';
import { EditUserContext, SelectedUsersContext } from '../../context';
import styles from './SearchPaneView.module.scss';
// takes one user and extracts user_id, name & phone number for UserCard
const flattenUser = user => {
  const data = { userId: user.person_id, name: '', phone: '' };

  const userInfoGenre = user.genres.find(v => v.name === 'user-info');
  if (!userInfoGenre) return data;

  const personalSection = userInfoGenre.sections.find(
    v => v.name === 'personal'
  );
  const phoneSection = userInfoGenre.sections.find(v => v.name === 'phone');

  if (personalSection) {
    const nameAttribute = personalSection.attribute_types.find(
      p => p.name === 'name'
    );
    if (nameAttribute && nameAttribute.attributes.length > 0) {
      data.name = nameAttribute.attributes[0].value;
    }
  }

  if (phoneSection) {
    const phoneAttribute = phoneSection.attribute_types.find(
      p => p.name === 'cell_phone'
    );
    if (phoneAttribute && phoneAttribute.attributes.length > 0) {
      data.phone = phoneAttribute.attributes[0].value;
    }
  }

  return data;
};

const SearchPaneView = ({ searchResults }) => {
  const formattedSortedSearchResults = searchResults.map(flattenUser);
  const { setEditUser } = useContext(EditUserContext);
  const { setSelectedUsers } = useContext(SelectedUsersContext);
  const [multiSelectView, setMultiSelectView] = useState(false);

  const openMultiSelectView = open => [
    setMultiSelectView(open),
    setSelectedUsers([]),
    setEditUser(false),
  ];

  const toggleMultiSelectView = () => openMultiSelectView(!multiSelectView);

  return (
    <div className={styles.main}>
      <SearchHeader
        contactCount={formattedSortedSearchResults.length > 0 ? formattedSortedSearchResults.length : 0}
        toggleMultiSelectView={toggleMultiSelectView}
      />
      {multiSelectView && (
        <SelectAllCheckbox searchResults={formattedSortedSearchResults} />
      )}
      {formattedSortedSearchResults.length > 0 ? (
        <div className={styles.userCardContainer}>
          {formattedSortedSearchResults.map(user => (
            <UserCard
              key={user.userId}
              multiSelectView={multiSelectView}
              user={user}
            />
          ))}
        </div>
      ) : (
        <div
          className={styles.noResults}
        >
          No results found
        </div>
      )}
    </div>
  );
};
SearchPaneView.propTypes = {
  searchResults: PropTypes.arrayOf(PropTypes.shape({
    user: PropTypes.shape({
      person_id: PropTypes.number,
      genres: PropTypes.arrayOf(GENRE_PROPTYPE),
    }),
  })),
};
SearchPaneView.defaultProps = { searchResults: [] };

export default SearchPaneView;
